import { useMemo } from 'react';
import styled from 'styled-components';

import { body2, caption, colors } from 'ui/theme';
import { getFromNow } from 'utils/date';

const Title = styled.div`
  ${body2}
`;

const Subtitle = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;
export type ListFilterOption = {
  id: number;
  name: string;
  updatedAt: string;
};

type FilterListValueOptionProps = {
  list: ListFilterOption;
};

export const FilterListValueOption = ({ list }: FilterListValueOptionProps) => {
  const updateText = useMemo(() => getFromNow(list.updatedAt), [list?.updatedAt]);

  return (
    <div>
      <Title>{list.name}</Title>
      <Subtitle>
        ID: {list.id} | Updated {updateText}
      </Subtitle>
    </div>
  );
};
